export default function() {
  const selectNavs = document.querySelectorAll('.js-nav-select');

  if (!selectNavs) return;

  selectNavs.forEach(select => {
    select.addEventListener('change', () => {
      window.location.assign(select.value);
    });
  });
}
